/* 🤖 this file was generated by svg-to-ts */
export const matIconPinEnd: {
  name: 'pin-end';
  data: string;
} = {
  name: 'pin-end',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 12V6H4v12h10v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-2zm-1 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-4.34-6H9v5.66h2v-2.24l2.95 2.95 1.41-1.41L12.41 10h2.24V8z"/></svg>`
};
